import { render, staticRenderFns } from "./Stonks.vue?vue&type=template&id=01a0f57a&"
import script from "./Stonks.vue?vue&type=script&lang=js&"
export * from "./Stonks.vue?vue&type=script&lang=js&"
import style0 from "./Stonks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports